import { render, staticRenderFns } from "./ReferenceHighlightTypeSelector.vue?vue&type=template&id=3bfa3e4a&"
import script from "./ReferenceHighlightTypeSelector.vue?vue&type=script&lang=js&"
export * from "./ReferenceHighlightTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports